<template>
    <div class="row nav-padding">
        <div class="form-inline px-3 pt-3">
            <div class="form-group width-300 fixed mr-3">
                <el-input
                    placeholder="Search for an email address"
                    prefix-icon="el-icon-search"
                    v-model="search_text"
                    :disabled="locked"
                    clearable
                    @change="handleSearch">
                </el-input>
            </div>

            <div class="form-group mr-3">
                <el-select v-model="search_account"
                           placeholder="Account"
                           :disabled="locked"
                           @change="getDomains">
                    <el-option
                        v-for="item in search_accounts"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>

            <div class="form-group mr-3">
                <el-select v-model="domain"
                           placeholder="Domain">
                    <el-option
                        v-for="item in domains"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>

            <div class="form-group">
                <el-button @click="handleSearch"
                           :disabled="locked || searching || !domain"
                           type="success">
                    Search
                </el-button>
            </div>
        </div>

        <div class="d-flex justify-content-start">
            <div v-if="results.length"
                 class="d-flex align-items-center mt-2 ml-4">
                <div>
                    <b>Results:</b> {{ results.length }}
                </div>
            </div>
        </div>

        <div class="w-100 pt-5">
            <div
                v-if="results && results.items && results.items.length"
                class="p-3">
                <el-table
                    :data="results.items"
                    class="width-100"
                    border>
                    <el-table-column
                        prop="address"
                        label="Email Address"
                        sortable>
                        <template v-slot="scope">
                            <div class="text-left">
                                <span>{{ scope.row.address }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="error"
                        label="Error">
                        <template v-slot="scope">
                            <div class="text-left">
                                <b>Error Code: {{ scope.row.code }}</b>
                                <p>
                                    {{ scope.row.error }}
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="created_at"
                        label="Created At">
                        <template v-slot="scope">
                            <div class="text-left">
                                <span>{{ scope.row.created_at }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="Operations"
                        align="center"
                        width="150"
                        fixed="right">
                        <template v-slot="scope">
                            <el-button type="danger"
                                       @click.prevent="removeBouncedEmail(scope.row)">
                                <i class="fa fa-spinner fa-spin"
                                   v-if="loading_delete && loading_delete == scope.row.address"></i>
                                <template v-else>
                                    <i class="fa fa-trash"></i>
                                    Delete
                                </template>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div v-else
                 class="h-100 d-flex align-items-center">
                <div v-if="searching"
                     class="w-100">
                    <h3 class="text-center">Loading...</h3>
                </div>

                <div v-else-if="no_results"
                     class="w-100">
                    <h3 class="text-center">No results.</h3>
                </div>

                <div v-else
                     class="w-100 search-resource-text">
                    <div class="text-center">
                        <i class="fa fa-search"></i>
                        <p class="mb-0">Search email suppression list</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            results: [],
            domains: [],
            domain: '',
            search_text: '',
            search_account: 'main',
            search_accounts: [
                {
                    'value': 'main',
                    'label': 'Mailgun Main',
                },
                {
                    'value': 'secure',
                    'label': 'Mailgun Secure',
                }
            ],
            searching: false,
            locked: false,
            no_results: false,
            loading_delete: null
        }
    },

    mounted() {
        this.getDomains()
    },

    methods: {
        getDomains() {
            this.locked = true
            axios.get('/api/admin/get-domains', {
                params: {
                    search_account: this.search_account
                }
            }).then(response => {
                let results = response.data.data
                if (results.total_count > 0) {
                    this.domains = results.items
                    this.domain = this.domains[0].id
                }
            }).catch(error => {
                this.$notify.error({
                    title: 'Error',
                    message: error.message
                })
            }).finally(() => this.locked = false)
        },

        handleSearch() {
            this.searching = true
            this.results = []

            axios.get('/api/admin/get-bounced-emails', {
                params: {
                    email: this.search_text,
                    domain: this.domain,
                    search_account: this.search_account
                }
            }).then(response => {
                let results = response.data.data

                if (results.length === undefined && results.address == this.search_text) {
                    results = {
                        domain: this.domain,
                        search_account: this.search_account,
                        items: [results]
                    }
                } else {
                    results.domain = this.domain
                    results.search_account = this.search_account
                }

                if (results.length !== undefined && results.length == 0) {
                    this.no_results = true
                } else {
                    this.no_results = false
                }

                this.results = results
            }).catch(error => {
                this.$notify.error({
                    title: 'Error',
                    message: error.message
                })
            }).finally(() => this.searching = false)
        },

        removeBouncedEmail(item) {
            this.$confirm(`Are you sure you want to remove ${item.address} bounced email address from the list. Continue?`, 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                customClass: 'width-500 fixed',
                type: 'warning'
            }).then(() => {
                this.loading_delete = item.address
                axios.delete('/api/admin/remove-bounced-emails', {
                    params: {
                        email: item.address,
                        domain: this.results.domain,
                        search_account: this.results.search_account
                    }
                }).then(res => {
                    this.$notify({
                        offset: 95,
                        title: 'Email Suppression',
                        message: res.data.data.message,
                        type: 'success',
                        showClose: true
                    })
                    this.results.items = this.results.items.filter(i => i.address != item.address)
                }).catch(err => {
                    this.$root.handleErrors(err.response)
                }).finally(() => this.loading_delete = null)
            })
        }
    }
}
</script>
